import APICall from "../utils/APICall"

export default class CardServices {
 static listCardRequests = async (page, pageLimit, search, from , to,cardStatus,cardType, deliveryType) =>{
     return await APICall(`/api/CardRequest/admin/list-card-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&cardStatus=${cardStatus}&cardType=${cardType}&deliveryType=${deliveryType}`, "GET");
 }
 static exportCardRequest = async (search, from, to,cardStatus,cardType) => {
     return await APICall(`/api/CardRequest/admin/export-card-request?search=${search}&from=${from}&to=${to}&cardStatus=${cardStatus}&cardType=${cardType}`, "GET")
 }
 static actionRequest = async (payload) => {
    return await APICall("/api/CardRequest/admin/action-card-request", "POST", payload)
 }
 static summary = async () =>{
    return await APICall(`/api/CardRequest/admin/card-request-summary`, "GET");
 }
}